






import { CollectionItem } from '@/resource/collection-item/collection-item.model';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class ItemTitle extends Vue {
  @Prop({ required: true })
  collectionItem!: CollectionItem;
}
